export enum Languages {
  EN = 'en',
  ZU = 'zu',
}
const I18N = {
  Languages,
};
export default I18N;
